/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
// import { ThemePalette } from '@angular/material/core';
import { AuthStateService } from 'app/auth/store/auth.state-service';
import { EDIT_USER_TITLE } from 'app/core/models/common-routing-types';
import {
  EditingStatus,
  UserType,
  userTypePDropdownItems,
} from 'app/core/models/common-types';
import { User, UserListItem, defaultUser, toUser, toUserListItem } from 'app/auth/model/User';
import { ConfirmationService, MessageService } from 'primeng/api';
import REGEX_TYPES, {
  validatePhoneNumber,
  formatPhoneNumber,
  validatePhoneInput,
} from 'app/shared/utils/rc-types/regex-types';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '@core/primeng.module';
import { ClientDropdownItem } from 'app/features/admin/clients/model/Client';
import { Router, ActivatedRoute } from '@angular/router';
import { ClientStateService } from '../../clients/store/client.state-service';

@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [CommonModule, PrimeNgModule, ReactiveFormsModule],
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent implements OnInit, OnDestroy {
  // @Input() selectedUser: User;
  // @Input() editUserForm: FormGroup;
  // //  @Input() isAdminUser: boolean;
  // @Output() onSaveUserEdit: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  // @Output() onCancelUserEdit: EventEmitter<void> = new EventEmitter<void>();
  // routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  pageTitle = EDIT_USER_TITLE;
  userListItems: UserListItem[] = [];
  selectedUserListItem: UserListItem;
  userEditingStatus = EditingStatus.EDITING;
  EditingStatus = EditingStatus;
  clientDropdownItems: ClientDropdownItem[];
  editUserForm: FormGroup;
  UserType = UserType;
  minDate: Date;
  maxDate: Date;
  userTypePDropdownItems = userTypePDropdownItems;

  private subscriptions = new Subscription();

  constructor(
    private authStateService: AuthStateService,
    private clientStateService: ClientStateService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService
  ) {
    this.route.params.subscribe((params) => {
      console.log('MS EditClientComponent params = ', params);
      if (params['editingStatus'] === 'EDITING') {
        this.userEditingStatus = EditingStatus.EDITING;
        this.pageTitle = EDIT_USER_TITLE;
      } else {
        this.userEditingStatus = EditingStatus.ADDING;
        this.pageTitle = 'Enter New User Info';
      }
    });
  }

  ngOnInit(): void {
    this.selectedUserListItem = toUserListItem(defaultUser, '');
    this.updateTheForm();

    // this.subscriptions.add(
    //   this.route.params.subscribe(params => {
    //     console.log('MS EditClientComponent params = ', params);
    //     if (params['editingStatus'] === 'EDITING') {
    //       this.userEditingStatus = EditingStatus.EDITING;
    //       this.pageTitle = EDIT_USER_TITLE;
    //     } else {
    //       this.userEditingStatus = EditingStatus.ADDING;
    //       this.pageTitle = 'Enter New User Info';
    //     }
    //   })
    // );
    this.subscriptions.add(
      this.clientStateService.clientDropdownItems$.subscribe((clientDropdownItems) => {
        this.clientDropdownItems = clientDropdownItems;
        console.log('MS EditUserComponent this.clientDropdownItems= ', this.clientDropdownItems);
      })
    );

    this.subscriptions.add(
      this.authStateService.userListItems$.subscribe((userListItems) => {
        this.userListItems = userListItems;
      })
    );

    this.subscriptions.add(
      this.authStateService.selectedUserListItem$.subscribe((selectedUserListItem) => {
        this.selectedUserListItem = selectedUserListItem;
        this.updateTheForm();
      })
    );
  }

  updateTheForm() {
    console.log('MS updateTheForm this.userEditingStatus= ', this.userEditingStatus);
    console.log('MS updateTheForm this.selectedUserListItem= ', this.selectedUserListItem);
    const clientDropdownItem = this.clientDropdownItems?.find((item) => item.id === this.selectedUserListItem.clientId);
    const userTypeItem = userTypePDropdownItems.find((item) => item.value === this.selectedUserListItem.userType);
    this.editUserForm = this.formBuilder.group({
      clientDropdownItem: [clientDropdownItem, Validators.required],
      isFirebaseUser: [this.selectedUserListItem.isFirebaseUser],
      isActive: [this.selectedUserListItem.isActive],
      first: [this.selectedUserListItem.first, Validators.required],
      last: [this.selectedUserListItem.last, Validators.required],
      email: [
        {
          value: this.selectedUserListItem.email,
          disabled: this.userEditingStatus === EditingStatus.EDITING,
        },
        [Validators.required, Validators.pattern(REGEX_TYPES.EMAIL)],
      ],
      phone: [this.selectedUserListItem.phone, [validatePhoneInput]],
      userTypeItem: [userTypeItem, Validators.required],
    });
    console.log('MS updateEditUserForm editUserForm= ', this.editUserForm);
  }

  onUserTypeSelected(event) {
    console.log('MS onUserTypeSelected event= ', event.value);
    // this.isClientCustomerUser = isClientCustomerUser(event.value);
  }

  onSaveUser() {
    console.log('MS onSaveUser this.editUserForm.value= ', this.editUserForm.value);
    if (validatePhoneNumber(this.editUserForm.value.phone)) {
      this.editUserForm.patchValue({
        phone: formatPhoneNumber(this.editUserForm.value.phone),
      });
    }
    const user = toUser(this.selectedUserListItem);
    const newUser: User = {
      ...user,
      first: this.editUserForm.value.first,
      isFirebaseUser: this.editUserForm.value.isFirebaseUser,
      isActive: this.editUserForm.value.isActive,
      last: this.editUserForm.value.last,
      email: this.editUserForm.value.email ?? this.selectedUserListItem.email,
      phone: this.editUserForm.value.phone,
      userType: this.editUserForm.value.userTypeItem.value,
      clientId: this.editUserForm.value.clientDropdownItem.id,
    };
    console.log('MS saveUser newUser= ', newUser);
    if (this.userEditingStatus === EditingStatus.ADDING) {
      const duplicate = this.userListItems.find((cl) => cl.email === this.editUserForm.value.email);
      if (duplicate) {
        this.confirmationService.confirm({
          header: 'Save New User Error',
          message: 'That email address is already in use!',
          icon: 'pi pi-exclamation-triangle',
          acceptIcon: 'none',
          rejectVisible: false,
          acceptLabel: 'OK',
          rejectButtonStyleClass: 'p-button-text',
          accept: () => {
            // this.messageService.add({ severity: 'info', summary: 'OK', detail: 'You have accepted' });
          },
          // reject: () => {
          //     this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
          // }
        });
        return;
      }
    }
    console.log('MS saveUser newUser= ', newUser);
    if (this.userEditingStatus === EditingStatus.EDITING) {
      this.authStateService.updateUser({
        ...newUser,
        id: this.selectedUserListItem.id,
      });
    } else {
      this.authStateService.addUser(newUser);
      // this.addAnother(newUser, 'Bill', 'Rogers', '425-895-8854');
      // this.addAnother(newUser, 'Fred', 'Adams', '425-895-8855');
      // this.addAnother(newUser, 'Tammy', 'Miller', '425-895-8856');
      // this.addAnother(newUser, 'Roger', 'Jones', '425-895-8857');
      // this.addAnother(newUser, 'Jonathan', 'Adler', '425-895-8858');
    }
    this.authStateService.setUserEditingStatus(EditingStatus.NOT_EDITING);
    this.router.navigate(['/admin/users-list']);
  }

  onCancelUser() {
    this.router.navigate(['/admin/users-list']);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
